
import Vue from "vue";
import { Plan } from "@/utils/payments/plan";
import { PriceFrequencyType } from "../../models/payment/pricing";
import { PaymentService, IUpgradePricing } from "../../services/payment-service";
import { printHumanFloat, printLocalDate } from "../../utils/pretty-print";
import { Mandat } from "../../models/payment/mandat";
import AppAwaitingPayment from "@/components/account/AwaitingPaymentModal.vue";
import { AuthService } from "@/services/auth-service";

export default Vue.extend({
	data(){
		return {
			awaitingPayment: false
		};
	},
	props: {
		plan: {
			type: Object as ()=>Plan,
			required: true
		},
		price: {
			type: Object as ()=>IUpgradePricing,
			required: true
		},
		mandate: {
			type: Object as ()=>Mandat
		}
	},
	computed: {
		activeUntill(): string{
			return printLocalDate(AuthService.wfCompany.ActiveUntil);
		},
		isYearInterval(): boolean {
			return this.plan.paymentFrequency == PriceFrequencyType.YEAR;
		},
		discountPrice(): string {
			return printHumanFloat(this.price);
		},
		pricePerMonth(): string {
			return printHumanFloat(this.price.pricing.recuringPrice.pricePerMonth);
		},
		totalPrice(): string {
			return printHumanFloat(this.price.pricing.recuringPrice.price);
		},
		upgradeCost(): string{
			return printHumanFloat(this.price.pricing.oneTimePrice.total);
		},
		hasVat():boolean{
			return this.price.pricing.recuringPrice.vat != 0;
		},
		vat():string{
			return printHumanFloat(this.price.pricing.recuringPrice.vat);
		},
		vatPercent():string{
			return printHumanFloat(this.price.pricing.recuringPrice.vatPercent, 0);
		},
		priceWithVat():string{
			return printHumanFloat(this.price.pricing.recuringPrice.total);
		},
		fromDate(): string {
			let date = new Date();
			return printLocalDate(date);
		},
		tillDate(): string {
			let date = new Date();
			if (this.plan.paymentFrequency == PriceFrequencyType.YEAR){
				date = new Date(date.setMonth(date.getMonth() + (12)));
			}else{
				date = new Date(date.setMonth(date.getMonth() + (3)));
			}
			return printLocalDate(date);
		},
		isPermanent():boolean {
			return AuthService.wfCompany.isPermanentlyActive();
		},
		buttonText(): string {
			return this.$ct("activate-upgrade", {amount: this.upgradeCost}).toString();
		}
	},
	methods: {
		async upgradeSubscription() {
			let mandateId = "";
			if (this.mandate){
				mandateId = this.mandate.id;
			}
			let shouldReload = await PaymentService.upgradeSubscription(this.plan.tier, this.plan.modules, mandateId);
			if (shouldReload){
				this.awaitingPayment = true;
			}
		},
		async upgradePermanent(){
			await PaymentService.permanentUpgrade(this.plan);
		},
		async upgradeClicked(){
			if (AuthService.wfCompany.isPermanentlyActive()) {
				this.upgradePermanent();
				return;
			}
			this.upgradeSubscription();
		}
	},
	components: {
		AppAwaitingPayment

	},
	i18nEx: {
		componentPrefix: "components.account"
	}
});
